import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_API_URL, DEFAULT_DATE_FORMATE } from '../../../constents';
import ReactDatePicker from 'react-datepicker';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import getValidTime from '../../../Utilities/makeTime';
import { format } from 'date-fns';
import { ssnInputMask } from '../../../Utilities/MaskInput';
import uploadfiles from '../../../Utilities/handleUploadFiles';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import Button from '../../Button';

const buildOptions = (arr, labelKey) =>
  (arr || []).map((item) => ({ value: item?.id, label: item?.[labelKey] }));

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

function Identity({ data, patientId, reload }) {
  const { user } = useSelector((state) => state.auth);
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const patImageRef = useRef(null);
  const idenImageRef = useRef(null);
  const [isEdit, setIsEdit] = useState(false);
  const [allDataEdit, setAllDataEdit] = useState(null);

  const [formValues, setFormValues] = useState({
    chart_number: '',
    dob: null,
    ssn: '',
    salutation: '',
    birth_time: null,
    mother_name: '',
    firstName: '',
    multiBirth: '',
    dateOfDeath: null,
    middleName: '',
    birth_order: '',
    reason: '',
    lastName: '',
    sex: '',
    financialClass: '',
    title: '',
    sexIdentity: '',
    identityType: '',
    prev_name: '',
    sexOrientation: '',
    identity_number: '',
    photograph: '',
    patientPhoto: '',
    identityPhoto: '',
    identity_photograph: '',
  });

  const handleIdentityChange = async () => {
    setIsEdit(true);
    try {
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        setAllDataEdit(response?.data);
        const patientDetails = response?.data?.patientDetail;
        //alert(patientDetails?.gender_identity);
        setFormValues((ele) => {
          return {
            ...ele,
            chart_number: patientDetails?.chart_number,
            dob:
              patientDetails?.date_of_birth === '0000-00-00' ||
              !patientDetails?.date_of_birth
                ? null
                : new Date(patientDetails?.date_of_birth),
            ssn: patientDetails?.ssn ? ssnInputMask(patientDetails?.ssn) : '',
            salutation: patientDetails?.patient_salutation,
            birth_time: patientDetails?.birth_time
              ? getValidTime(new Date(), patientDetails?.birth_time)
              : null,
            mother_name: patientDetails?.mother_name,
            firstName: patientDetails?.first_name,
            multiBirth: patientDetails?.multi_birth,
            dateOfDeath:
              patientDetails?.date_of_death &&
              patientDetails?.date_of_death !== '0000-00-00'
                ? new Date(patientDetails?.date_of_death)
                : null,
            middleName: patientDetails?.middle_name,
            birth_order: patientDetails?.birth_order,
            reason: patientDetails?.patient_reason,
            lastName: patientDetails?.last_name,
            sex: patientDetails?.gender,
            financialClass: patientDetails?.patient_fin_class,
            title: patientDetails?.patient_title,
            sexIdentity: patientDetails?.gender_identity,
            identityType: patientDetails?.identity_type,
            prev_name: patientDetails?.prev_name,
            sexOrientation: patientDetails?.sex_orientation,
            identity_number: patientDetails?.identity_number,
            photograph: patientDetails?.photograph,
            patientPhoto: patientDetails?.patientPhoto,
            identity_photograph: patientDetails?.identity_photograph,
            identityPhoto: patientDetails?.identityPhoto,
          };
        });
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleSave = async () => {
    if (formValues?.identityType && formValues?.identityType !== '0') {
      if (!formValues?.identity_number) {
        setUiMessage('err', 'Please fill identity number');
      } else if (
        !formValues?.identityPhoto ||
        formValues?.identityPhoto ===
          'http://localhost/connect_health_4.10.01-32190/images/no-image.jpg'
      ) {
        setUiMessage('err', 'Please upload identity card image');
      } else {
        setIsEdit(false);

        try {
          const response = await post('api/patient/Patient/updatePatient', {
            updateInfo: 'Identity-Details',
            flag: '1',
            patient_id: patientId,
            patient_salutation: formValues?.salutation,
            first_name: formValues?.firstName,
            middle_name: formValues?.middleName,
            last_name: formValues?.lastName,
            prev_name: formValues?.prev_name,
            patient_title: formValues?.title,
            gender: formValues?.sex,
            sex_orientation: formValues?.sexOrientation,
            sex_orientation_desc: '',
            gender_identity: formValues?.sexIdentity,
            gender_identity_desc: '',
            date_of_birth: formValues?.dob
              ? format(formValues?.dob, DEFAULT_DATE_FORMATE)
              : '',
            birth_time: formValues?.birth_time
              ? format(formValues?.birth_time, 'hh:mm a')
              : '',
            photograph: formValues?.photograph,
            multi_birth: formValues?.multiBirth,
            birth_order: formValues?.birth_order,
            ssn: formValues?.ssn,
            mother_name: formValues?.mother_name,
            patient_fin_class: formValues?.financialClass,
            date_of_death: formValues?.dateOfDeath
              ? format(formValues?.dateOfDeath, DEFAULT_DATE_FORMATE)
              : '',
            patient_reason: formValues?.reason,
            identity_type: formValues?.identityType,
            identity_no: formValues?.identity_number,
            capturedPhotoImageName: '',
            insScanFilePathIdentity: '',
            snapCaptureLoc: '',
            identity_photo: formValues?.identity_photograph,
            loginUserId: user?.id,
          });
          if (response?.status === 200) {
            reload();
          }
        } catch (e) {
          setUiMessage('err', e.message);
        }
      }
    } else {
      setIsEdit(false);

      try {
        const response = await post('api/patient/Patient/updatePatient', {
          updateInfo: 'Identity-Details',
          flag: '1',
          patient_id: patientId,
          patient_salutation: formValues?.salutation,
          first_name: formValues?.firstName,
          middle_name: formValues?.middleName,
          last_name: formValues?.lastName,
          prev_name: formValues?.prev_name,
          patient_title: formValues?.title,
          gender: formValues?.sex,
          sex_orientation: formValues?.sexOrientation,
          sex_orientation_desc: '',
          gender_identity: formValues?.sexIdentity,
          gender_identity_desc: '',
          date_of_birth: formValues?.dob
            ? format(formValues?.dob, DEFAULT_DATE_FORMATE)
            : '',
          birth_time: formValues?.birth_time
            ? format(formValues?.birth_time, 'hh:mm a')
            : '',
          photograph: formValues?.photograph,
          multi_birth: formValues?.multiBirth,
          birth_order: formValues?.birth_order,
          ssn: formValues?.ssn,
          mother_name: formValues?.mother_name,
          patient_fin_class: formValues?.financialClass,
          date_of_death: formValues?.dateOfDeath
            ? format(formValues?.dateOfDeath, DEFAULT_DATE_FORMATE)
            : '',
          patient_reason: formValues?.reason,
          identity_type: formValues?.identityType,
          identity_no: formValues?.identity_number,
          capturedPhotoImageName: '',
          insScanFilePathIdentity: '',
          snapCaptureLoc: '',
          identity_photo: formValues?.identity_photograph,
          loginUserId: user?.id,
        });
        if (response?.status === 200) {
          reload();
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    }
  };

  const handleFieldChange = ({ target: { id, value } }) => {
    if (id === 'ssn') {
      setFormValues((ele) => {
        return { ...ele, ssn: ssnInputMask(value).replace(/[^0-9-]/g, '') };
      });
    } else {
      setFormValues((ele) => {
        return { ...ele, [id]: value };
      });
    }
  };

  const handleSelectChange = (id, option) => {
    setFormValues((ele) => {
      return { ...ele, [id]: option ? option.value : '' };
    });
  };

  const setPatDob = (dob) => {
    setFormValues((ele) => {
      return { ...ele, dob: dob };
    });
  };

  const setPatDodeth = (dod) => {
    setFormValues((ele) => {
      return { ...ele, dateOfDeath: dod };
    });
  };

  const handlTimeSelect = (time) => {
    setFormValues((ele) => {
      return { ...ele, birth_time: time };
    });
  };

  const handleBrousePatImageClick = () => {
    patImageRef.current.click();
  };

  const handleCameraPatImageClick = () => {
    patImageRef.current.setAttribute('capture', 'camera');
    patImageRef.current.click();
    patImageRef.current.removeAttribute('capture');
  };

  const handleBrouseIdentityImageClick = () => {
    idenImageRef.current.click();
  };

  const handleCameraIdentityImageClick = () => {
    idenImageRef.current.setAttribute('capture', 'camera');
    idenImageRef.current.click();
    idenImageRef.current.removeAttribute('capture');
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const apiUrl = `${DEFAULT_API_URL}/api/patient/Patient/uploadImage`;
      const responce = await uploadfiles(apiUrl, file);
      if (responce.data?.successCode === 'success') {
        setFormValues((ele) => {
          return {
            ...ele,
            patientPhoto: responce.data?.flePathName,
          };
        });
        setFormValues((ele) => {
          return {
            ...ele,
            photograph: responce.data?.fleName,
          };
        });
        patImageRef.current.value = '';
      } else {
        setUiMessage('err', 'Please select file');
      }
    }
  };
  const handleIdentityFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const apiUrl = `${DEFAULT_API_URL}/api/patient/Patient/uploadImage`;
      const responce = await uploadfiles(apiUrl, file);
      if (responce.data?.successCode === 'success') {
        setFormValues((ele) => {
          return {
            ...ele,
            identityPhoto: responce.data?.flePathName,
          };
        });
        setFormValues((ele) => {
          return {
            ...ele,
            identity_photograph: responce.data?.fleName,
          };
        });
        idenImageRef.current.value = '';
      } else {
        setUiMessage('err', 'Please select file');
      }
    }
  };

  const handleRemovePatImage = () => {
    setFormValues((ele) => {
      return {
        ...ele,
        patientPhoto: '',
      };
    });
    setFormValues((ele) => {
      return {
        ...ele,
        photograph: '',
      };
    });
  };
  const handleRemoveIdentityImage = () => {
    setFormValues((ele) => {
      return {
        ...ele,
        identityPhoto: '',
      };
    });
    setFormValues((ele) => {
      return {
        ...ele,
        identity_photograph: '',
      };
    });
  };

  return (
    <>
      {isEdit ? (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Identity:</div>
            <div
              className="chld-hdr-edt"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant="default"
                onClick={() => setIsEdit(false)}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Chart ID:</span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="chart_number"
                    value={formValues.chart_number}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  DOB:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  <ReactDatePicker
                    selected={formValues.dob || null}
                    onChange={(date) => setPatDob(date)}
                    className="inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">SSN:</span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="ssn"
                    value={formValues.ssn}
                    onChange={handleFieldChange}
                    maxLength="11"
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Salutation:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const salutationOptions = [
                      ...buildOptions(
                        allDataEdit?.identityDetailArr?.salutation,
                        'title'
                      ),
                      { value: '2', label: 'Captain' },
                      { value: '3', label: 'Colonel' },
                    ];
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          salutationOptions,
                          formValues.salutation
                        )}
                        options={salutationOptions}
                        onChange={(opt) =>
                          handleSelectChange('salutation', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Birth time:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    selected={formValues.birth_time}
                    onChange={(date) => handlTimeSelect(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Time"
                    // dateFormat="h:mm aa"
                    dateFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : 'h:mm aa'
                    } // Conditional date format
                    timeFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : undefined
                    } // Conditional time format
                    placeholderText="00:00"
                    className="inpt-width-nw"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Mother Name:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="mother_name"
                    value={formValues.mother_name || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>

            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  First Name:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="firstName"
                    value={formValues.firstName || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Multiple Birth:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const multiBirthOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.multipleBirthIndicator,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          multiBirthOptions,
                          formValues.multiBirth
                        )}
                        options={multiBirthOptions}
                        onChange={(opt) =>
                          handleSelectChange('multiBirth', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Date of Death:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    selected={formValues.dateOfDeath}
                    onChange={(date) => setPatDodeth(date)}
                    className="inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Middle Name:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="middleName"
                    value={formValues.middleName || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Birth Order:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const birthOrderOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.birthOrder,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          birthOrderOptions,
                          formValues.birth_order
                        )}
                        options={birthOrderOptions}
                        onChange={(opt) =>
                          handleSelectChange('birth_order', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Reason:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Please write the reason here..."
                    id="reason"
                    value={formValues.reason || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Last Name:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="lastName"
                    value={formValues.lastName || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">
                  Sex:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  {(() => {
                    const sexOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.sex,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(sexOptions, formValues.sex)}
                        options={sexOptions}
                        onChange={(opt) => handleSelectChange('sex', opt)}
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Financial Class:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const financialClassOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.financialClass,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          financialClassOptions,
                          formValues.financialClass
                        )}
                        options={financialClassOptions}
                        onChange={(opt) =>
                          handleSelectChange('financialClass', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Title:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const titleOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.title,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          titleOptions,
                          formValues.title
                        )}
                        options={titleOptions}
                        onChange={(opt) => handleSelectChange('title', opt)}
                      />
                    );
                  })()}
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Sex Identity:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const sexIdentityOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.sexIdentity,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          sexIdentityOptions,
                          formValues.sexIdentity
                        )}
                        options={sexIdentityOptions}
                        onChange={(opt) =>
                          handleSelectChange('sexIdentity', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Identity Type:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const identityTypeOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.identityType,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          identityTypeOptions,
                          formValues.identityType
                        )}
                        options={identityTypeOptions}
                        onChange={(opt) =>
                          handleSelectChange('identityType', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Prev. Name:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="prev_name"
                    value={formValues.prev_name || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Sex Orientation:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const sexOrientationOptions = buildOptions(
                      allDataEdit?.identityDetailArr?.sexOrientation,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          sexOrientationOptions,
                          formValues.sexOrientation
                        )}
                        options={sexOrientationOptions}
                        onChange={(opt) =>
                          handleSelectChange('sexOrientation', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Identity Number:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="identity_number"
                    value={formValues.identity_number || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy flex-sec demo-img-blk">
            <div
              className="demo-main-con-chld-bdy-rw"
              style={{ flexBasis: '50%' }}
            >
              <span className="nsu-act-lbl">Patient Image:</span>
              <div className="nsu-act-val grid-sec">
                <div className=" width100">
                  <div
                    className="actn-yes"
                    style={{
                      width: 'unset',
                      padding: '3px 12px',
                      marginLeft: '0px',
                      float: 'left',
                    }}
                    onClick={handleCameraPatImageClick}
                  >
                    Camera
                  </div>
                  <div
                    className="actn-yes"
                    style={{
                      width: 'unset',
                      padding: '3px 12px',
                      float: 'left',
                    }}
                    onClick={handleBrousePatImageClick}
                  >
                    Browse
                  </div>
                  <input
                    type="file"
                    ref={patImageRef}
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                  />
                </div>
                <div className="width100">
                  <img
                    className="pat-img"
                    src={formValues.patientPhoto}
                    alt=""
                  />
                </div>
                <div className="width100">
                  <Link onClick={handleRemovePatImage} className="prnt-card">
                    Remove
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="demo-main-con-chld-bdy-rw"
              style={{ flexBasis: '50%' }}
            >
              <span className="nsu-act-lbl">Identity Card:</span>
              <div className="nsu-act-val grid-sec">
                <div className="width100">
                  <div
                    className="actn-yes"
                    style={{
                      width: 'unset',
                      padding: '3px 12px',
                      marginLeft: '0px',
                      float: 'left',
                    }}
                    onClick={handleCameraIdentityImageClick}
                  >
                    Camera
                  </div>
                  <div
                    className="actn-yes"
                    style={{
                      width: 'unset',
                      padding: '3px 12px',
                      float: 'left',
                    }}
                    onClick={handleBrouseIdentityImageClick}
                  >
                    Browse
                  </div>
                  <input
                    type="file"
                    ref={idenImageRef}
                    style={{ display: 'none' }}
                    onChange={handleIdentityFileSelect}
                  />
                </div>
                <div className="width100 clear-top10">
                  <img
                    className="identity-img"
                    src={formValues.identityPhoto}
                    alt=""
                  />
                </div>
                <div className="flex-sec">
                  <Link
                    onClick={handleRemoveIdentityImage}
                    className="prnt-card"
                  >
                    Remove
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Identity:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn" onClick={handleIdentityChange}>
                &#9998;
              </span>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Chart ID:</span>
                <span className="nsu-act-val maroon">{data?.chart_number}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">DOB:</span>
                <span className="nsu-act-val maroon">{data?.dob}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">SSN:</span>
                <span className="nsu-act-val maroon">{data?.ssn}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Salutation:</span>
                <span className="nsu-act-val">{data?.salutation}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Birth time:</span>
                <span className="nsu-act-val">{data?.birth_time}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Mother Name:</span>
                <span className="nsu-act-val">{data?.mother_name}</span>
              </div>
            </div>

            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">First Name:</span>
                <span className="nsu-act-val maroon">{data?.firstName}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Multiple Birth:</span>
                <span className="nsu-act-val">{data?.multiBirth}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Date of Death:</span>
                <span className="nsu-act-val">{data?.dateOfDeath || '-'}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Middle Name:</span>
                <span className="nsu-act-val">{data?.middleName}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Birth Order:</span>
                <span className="nsu-act-val">{data?.birth_order}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Reason:</span>
                <span className="nsu-act-val">{data?.reason}</span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Last Name:</span>
                <span className="nsu-act-val maroon">{data?.lastName}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Sex:</span>
                <span className="nsu-act-val maroon">{data?.sex}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Financial Class:</span>
                <span className="nsu-act-val">{data?.financialClass}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Title:</span>
                <span className="nsu-act-val">{data?.title}</span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Sex Identity:</span>
                <span className="nsu-act-val">{data?.sexIdentity}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Identity Type:</span>
                <span className="nsu-act-val">{data?.identityType}</span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Prev. Name:</span>
                <span className="nsu-act-val">{data?.prev_name}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Sex Orientation:</span>
                <span className="nsu-act-val">{data?.sexOrientation}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Identity Number:</span>
                <span className="nsu-act-val">{data?.identity_number}</span>
              </div>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy flex-sec demo-img-blk">
            <div
              className="demo-main-con-chld-bdy-rw"
              style={{ flexBasis: '50%' }}
            >
              <span className="nsu-act-lbl">Patient Image:</span>
              <span className="nsu-act-val">
                <span className="">
                  <img
                    className="pat-img"
                    src={`${data?.patientPhoto}`}
                    alt=""
                  />
                </span>
                <span className="flex-sec">
                  {/* <Link className="prnt-card">Print</Link> */}
                </span>
              </span>
            </div>
            <div
              className="demo-main-con-chld-bdy-rw"
              style={{ flexBasis: '50%' }}
            >
              <span className="nsu-act-lbl">Identity Card:</span>
              <span className="nsu-act-val">
                <span className="">
                  <img
                    className="identity-img"
                    src={`${data?.identityPhoto}`}
                    alt=""
                  />
                </span>
                <span className="flex-sec">
                  {/* <Link className="prnt-card">Print</Link> */}
                </span>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Identity;
